
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/podcast",
      function () {
        return require("private-next-pages/m/podcast.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/podcast"])
      });
    }
  